/* eslint-disable import/prefer-default-export */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { findNav, setResponsiveNav, setResponsiveToggle } from '@aarhus-university/au-designsystem-delphinus/source/js/components/nav';
import { useCallback } from 'react';

let windowInnerWidth = 0;
export const useSetResponsiveNavigation = (
  navElementsSelector: string,
  navSelector: string,
): any => useCallback((node: HTMLElement | null) => {
  if (node !== null) {
    const navElements = document.querySelectorAll(navElementsSelector);
    const navRef = findNav(node);
    setResponsiveNav(navElements, navRef);
    setResponsiveToggle(navElements);

    windowInnerWidth = window.innerWidth;

    window.addEventListener('resize', () => {
      if (windowInnerWidth > 0 && window.innerWidth !== windowInnerWidth) {
        windowInnerWidth = window.innerWidth;
        setResponsiveNav(navElements, navRef);
      }
    });

    const nav = document.querySelector(navSelector);
    if (nav?.querySelector('.nav__item--active')) {
      nav.classList.add('nav--has-active-item');
    }
  }
}, []);
